export const handleRouter = (link: string) => {
  window.location.href = `${link}`
}

export const handleLink = (link: string) => {
  window.open(link, '_blank')
}
